import { styled } from '@mui/material';
import { Box } from 'shared/mui/Box';
import { Create } from 'shared/react-admin/Create/Create';

export const CreateStyled = styled(Create)({
  margin: 0,
  '& .RaCreate-main': {
    marginTop: 0,
  },
});

export const BoxStyled = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
});

export const EventsBoxStyled = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
});
